// 基础数据类型原型方法扩展

String.prototype.EndWith = function (endStr) {
    let d = this.length - endStr.length;
    return (d >= 0 && this.lastIndexOf(endStr) == d)
}

String.prototype.AddRandom = function (endStr) {
    let d = this.length - endStr.length;
    return (d >= 0 && this.lastIndexOf(endStr) == d)
}

String.prototype.UpperFirstChar = function () {
    if (this == undefined || this == "") {
        return this;
    }
    return `${this.substring(0, 1).toUpperCase()}${this.substring(1)}`;
}

String.prototype.SecretPhone = function () {
    if (Number(this) && String(this).length === 11) {
        let mobile = String(this)
        let reg = /^(\d{3})\d{4}(\d{4})$/
        return mobile.replace(reg, '$1****$2')
    } else {
        return this;
    }
}

Array.prototype.Where = function (func) {
    let list = [];
    for (let i = 0; i < this.length; i++) {
        if (func(this[i], i)) {
            let d = this[i];
            if (IsObj(d)) {
                d.__index = i;
            }
            list.push(d);
        }
    }
    return list;
}
Array.prototype.Take = function (qty) {
    return this.splice(0, qty);
}
Array.prototype.Skip = function (qty) {
    return this.splice(qty);
}
Array.prototype.Find = function (func) {
    for (let i = 0; i < this.length; i++) {
        if (func(this[i], i)) {
            let d = this[i];
            if (IsObj(d)) {
                d.__index = i;
            }
            return d;
        }
    }
    return undefined;
}
Array.prototype.Any = function (func) {
    for (let i = 0; i < this.length; i++) {
        if (func(this[i], i)) {
            return true;
        }
    }
    return false;
}
Array.prototype.Sum = function (func) {
    let _num = 0;
    for (let i = 0; i < this.length; i++) {
        if (func(this[i], i)) {
            _num += func(this[i], i);
        }
    }
    return _num;
}
Array.prototype.Count = function (func) {
    let _num = 0;
    for (let i = 0; i < this.length; i++) {
        if (func(this[i], i)) {
            _num += 1;
        }
    }
    return _num;
}
Array.prototype.Delete = function (func) {
    for (let i = 0; i < this.length; i++) {
        if (func(this[i], i)) {
            this.splice(i, 1);
            i--;
        }
    }
    return this;
}
Array.prototype.Remove = function (index, length) {
    length = length || 1;
    this.splice(index, length);
}
Array.prototype.Select = function (func) {
    let arr = [];
    for (let i = 0; i < this.length; i++) {
        arr.push(func(this[i], i));
    }
    return arr;
}
Array.prototype.Each = function (func) {
    for (let i = 0; i < this.length; i++) {
        func(this[i], i)
    }
}

Number.prototype.TryParseInt = function (def) {
    let num = parseInt(this);
    if (isNaN(num)) {
        num = def || 0;
    }
    return num;
}
String.prototype.TryParseInt = function (def) {
    let num = parseInt(this);
    if (isNaN(num)) {
        num = def || 0;
    }
    return num;
}
String.prototype.Format = function (fmt) {
    return new Date(this).Format(fmt);
}
Date.prototype.Format = function (fmt) { //author: meizz   
    var o = {
        "M+": this.getMonth() + 1,                 //月份   
        "d+": this.getDate(),                    //日   
        "H+": this.getHours(),                   //小时   
        "m+": this.getMinutes(),                 //分   
        "s+": this.getSeconds(),                 //秒   
        "S": this.getMilliseconds()             //毫秒   
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

function IsObj(d) {
    return Object.prototype.toString.call(d) === '[object Object]';
}
